import { useCart } from "../CartContext";
import LoadStripe from "../LoadStripe";
import StripeForm from "../StripeForm";

type Props = {
  setProcessing: (state: boolean) => void;
  stripePublicKey: string;
  successURL: string;
};

export const PaymentSection = function PaymentSection({
  setProcessing,
  stripePublicKey,
  successURL,
}: Props) {
  const { data, isSubmitting: isProcessing } = useCart();
  if (!data) return null;
  const submitButtonText = isProcessing
    ? "Processing..."
    : "Complete Your Enrollment";

  return (
    <div>
      {data.paymentIntent?.clientSecret ? (
        <LoadStripe
          clientSecret={data.paymentIntent.clientSecret}
          stripePublicKey={stripePublicKey}
        >
          <div className="checkout-payment-form pt-8">
            <StripeForm
              isProcessing={isProcessing}
              setProcessing={setProcessing}
              successURL={successURL}
              submitButtonText={submitButtonText}
            />
          </div>
        </LoadStripe>
      ) : null}
    </div>
  );
};
